import { FarmQualityMark, QualityMarkId } from 'types/ListingData';

export const NG_QUALITY_MARK_GROUP_ID = 'ng-medala';

export const GROUPED_QUALITY_MARKS_URL = 'api/v2/qmark?group_ng=1';

export interface QualityMarkOption {
  id: QualityMarkId;
  name: string;
  slug?: string;
  logo?: string;
  hidden?: number | boolean;
  member_ids?: number[];
}

const LISTING_PRIMARY_QUALITY_MARK_SLUGS = [
  'biologiskais',
  'zala-karotite',
  'bordo-karotite',
  'integretais-audzetajs',
];

export const toListingQualityMarkOptions = (
  marks?: QualityMarkOption[] | null
): FarmQualityMark[] => {
  const primaryIndex = (mark: QualityMarkOption) =>
    LISTING_PRIMARY_QUALITY_MARK_SLUGS.indexOf(mark.slug ?? '');

  const visible = (marks ?? []).filter((mark) => !Number(mark.hidden));
  const primary = visible
    .filter((mark) => primaryIndex(mark) !== -1)
    .sort((a, b) => primaryIndex(a) - primaryIndex(b));
  const secondary = visible.filter((mark) => primaryIndex(mark) === -1);

  return [
    ...primary.map((mark) => ({
      value: mark.id,
      label: mark.name,
      className: 'quality-mark-primary',
    })),
    ...secondary.map((mark) => ({
      value: mark.id,
      label: mark.name,
      className: 'quality-mark-secondary',
    })),
  ];
};

const WIDE_QUALITY_MARK_SLUGS = ['zala-karotite', 'bordo-karotite'];

export const qualityMarkLogoClassName = (slug?: string | null) =>
  WIDE_QUALITY_MARK_SLUGS.includes(slug ?? '') ? 'quality-mark-wide' : '';

export const isSameQualityMarkId = (
  a: QualityMarkId | null | undefined,
  b: QualityMarkId | null | undefined
): boolean => a != null && b != null && String(a) === String(b);

export const findQualityMark = <T extends { id: QualityMarkId }>(
  marks: T[] | null | undefined,
  id: QualityMarkId
): T | undefined => marks?.find((mark) => isSameQualityMarkId(mark.id, id));

export const hasRequiredQualityMark = (
  requiredId: QualityMarkId,
  ownedIds: QualityMarkId[],
  allMarks?: QualityMarkOption[] | null
): boolean => {
  if (ownedIds.some((id) => isSameQualityMarkId(id, requiredId))) {
    return true;
  }

  const members = findQualityMark(allMarks, requiredId)?.member_ids ?? [];

  return members.some((memberId) =>
    ownedIds.some((id) => isSameQualityMarkId(id, memberId))
  );
};

export const hasAllRequiredQualityMarks = (
  requiredIds: QualityMarkId[],
  ownedIds: QualityMarkId[],
  allMarks?: QualityMarkOption[] | null
): boolean =>
  requiredIds.every((requiredId) =>
    hasRequiredQualityMark(requiredId, ownedIds, allMarks)
  );
